import { FaCheck, FaRegCircle } from "react-icons/fa";

type Props = {
  senha: string;
};

// O backend exige apenas 8 caracteres. Os demais itens são sugestões e não
// impedem o cadastro.
export default function RegrasSenha({ senha }: Props) {
  const item = (texto: string, ok: boolean) => (
    <li
      key={texto}
      className={`flex items-center gap-2 ${ok ? "text-gray-900" : "text-gray-500"}`}
    >
      {ok ? (
        <FaCheck className="shrink-0 text-mygreen" />
      ) : (
        <FaRegCircle className="shrink-0" />
      )}
      {texto}
    </li>
  );

  return (
    <div className="mt-3 text-xs space-y-3">
      <div>
        <p className="font-semibold text-gray-900 mb-1">A senha deve conter:</p>
        <ul className="space-y-1">
          {item("No mínimo 8 caracteres", senha.length >= 8)}
        </ul>
      </div>
      <div>
        <p className="font-semibold text-gray-900 mb-1">
          Para deixá-la mais forte, use também:
        </p>
        <ul className="space-y-1">
          {item("Pelo menos 1 letra maiúscula", /[A-ZÀ-Ý]/.test(senha))}
          {item("Pelo menos 1 letra minúscula", /[a-zà-ÿ]/.test(senha))}
          {item("Pelo menos 1 número", /\d/.test(senha))}
          {item("Pelo menos 1 caractere especial", /[^A-Za-zÀ-ÿ0-9\s]/.test(senha))}
        </ul>
      </div>
    </div>
  );
}
